import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("事故車の場合、")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("加算対象 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" の入力で")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 円アップ！ ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 現在、買取金額")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 円アップ！ ")
const _hoisted_13 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scrap_form_stepper = _resolveComponent("scrap-form-stepper")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_scrap_form = _resolveComponent("scrap-form")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_scrap_form_stepper, {
      value: _ctx.currentStep,
      class: "q-mb-lg"
    }, null, 8, ["value"]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.incentive, "q-mb-lg"])
    }, [
      (_ctx.currentStep === 7)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2,
            (_ctx.$q.screen.lt.md)
              ? (_openBlock(), _createElementBlock("br", _hoisted_3))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      _hoisted_4,
      _createVNode(_component_q_badge, {
        label: "ＵＰ",
        color: "orange",
        style: {"transform":"translateY(-6px)"}
      }),
      _hoisted_5,
      (_ctx.$q.screen.lt.sm)
        ? (_openBlock(), _createElementBlock("br", _hoisted_6))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createElementVNode("span", null, _toDisplayString(_ctx.addAmount[`form${_ctx.currentStep}`]), 1),
      _hoisted_8
    ], 2),
    _createVNode(_component_scrap_form, {
      ref: "scrapFormRef",
      modelValue: _ctx.currentStep,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentStep) = $event)),
      class: "q-mb-lg"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_q_separator, {
      spaced: "xl",
      color: "grey"
    }),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.formButtons, "q-mb-lg"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['formButtons--more'])
      }, [
        (_ctx.currentStep < 7)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              unelevated: "",
              onClick: _ctx.toNext,
              color: "primary",
              size: "lg",
              label: "さらに入力で金額アップ",
              class: _normalizeClass(_ctx.$style['formButtons--moreButton']),
              "icon-right": "north_east"
            }, null, 8, ["onClick", "class"]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['formButtons--back'])
      }, [
        (_ctx.currentStep > 1)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              flat: "",
              padding: "sm none",
              onClick: _ctx.toBack,
              color: "primary",
              label: "戻る",
              icon: "arrow_back",
              class: _normalizeClass(_ctx.$style['formButtons--backButton'])
            }, null, 8, ["onClick", "class"]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['formButtons--skip'])
      }, [
        _createVNode(_component_q_btn, {
          flat: "",
          padding: "sm none",
          onClick: _ctx.toSkip,
          color: "primary",
          label: "この項目をスキップ",
          "icon-right": "arrow_forward",
          class: _normalizeClass(_ctx.$style['formButtons--skipButton'])
        }, null, 8, ["onClick", "class"])
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.incentive, "q-mb-lg"])
    }, [
      _hoisted_9,
      (_ctx.$q.screen.lt.sm)
        ? (_openBlock(), _createElementBlock("br", _hoisted_10))
        : _createCommentVNode("", true),
      _hoisted_11,
      _createElementVNode("span", null, _toDisplayString(_ctx.totalIncentiveForDisplay), 1),
      _hoisted_12
    ], 2),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_q_btn, {
        unelevated: "",
        onClick: _ctx.toConfirm,
        color: "brand",
        label: "ここまでの入力内容でお見積り依頼",
        "icon-right": "table_view"
      }, null, 8, ["onClick"])
    ])
  ]))
}